// Pure display-state helpers shared between the store/saga layer and the UI components.
// Keeping them in utils/ prevents a circular dependency where store/sagas import from components/.

export const DISPLAY_STATE = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed',
    HIDDEN: 'hidden',
};

// Constant used by the new-wall handoff mechanism. Lives here so that both the saga
// (which reads/writes sessionStorage) and the URL builder (component layer) can import
// from utils/ without creating a store -> components import cycle.
export const VIDEO_WALL_HANDOFF_STORAGE_KEY = 'videoWallHandoffId';

/** Convert a DISPLAY_STATE value to the `hidden` / `collapsed` boolean flags used in the store. */
export const displayStateToFlags = (state) => ({
    hidden: state !== DISPLAY_STATE.EXPANDED,
    collapsed: state === DISPLAY_STATE.COLLAPSED,
});

/** Reconstruct a DISPLAY_STATE value from the `hidden` / `collapsed` boolean flags. */
export const displayStateFromFlags = (hidden, collapsed) =>
    collapsed ? DISPLAY_STATE.COLLAPSED : hidden ? DISPLAY_STATE.HIDDEN : DISPLAY_STATE.EXPANDED;

/** Seed the initial display state for a camera from current store data. */
export const seedDisplayState = (camera, collapsedIds) => displayStateFromFlags(camera.hidden, (collapsedIds || []).includes(camera.id));
